module.exports = __webpack_public_path__ + "img/wifi-test2.c0e456a.png";